import type { IconName } from "@@/shared/icon-name";
import type { Translatable} from "@@/shared/translations/translation";
import { translation } from "@@/shared/translations/translation";
import { toObjectMap } from "@@/utilities/dictionary";
import { z } from "zod";

const singleContentPageBlockLayoutTypes = [
    "leftToRight",
    "rightToLeft",
] as const;
type SingleContentPageBlockLayoutType =
    (typeof singleContentPageBlockLayoutTypes)[number];
const singleContentPageBlockLayoutType =
    toObjectMap<SingleContentPageBlockLayoutType>([
        ...singleContentPageBlockLayoutTypes,
    ]);

const singleContentPageBlockLayoutTypeMeta: Record<
    SingleContentPageBlockLayoutType,
    {
        iconName: IconName;
        name: Translatable;
    }
> = {
    leftToRight: {
        iconName: "fa-arrow-right",
        name: translation({
            sv: "Vänster till höger",
            en: "Left to right",
        }),
    },
    rightToLeft: {
        iconName: "fa-arrow-left",
        name: translation({
            sv: "Höger till vänster",
            en: "Right to left",
        }),
    },
};
const singleContentPageBlockLayoutTypeZodSchema = z.enum(
    singleContentPageBlockLayoutTypes,
);

export {
    singleContentPageBlockLayoutType,
    singleContentPageBlockLayoutTypeMeta,
    singleContentPageBlockLayoutTypeZodSchema,
};
export type { SingleContentPageBlockLayoutType };
